import commonHelper from '@/app/utility/common.helper.utility';
import URL_UTILITY from '../../../../../utility/url.utility';
import previewDoc from '../../../../onlineApproval/internalWorkFlow/history/uploadDocument/previewDoc';
export default {
  name: 'Bank',
  components: { previewDoc },
  props: [
    'partyRowDetails',
    'urlSummaryData',
    'workflowId',
    'dashboardDetails'
  ],
  data() {
    return {
      loader: false,
      bankData: [],
      bankFields: [
        {
          key: 'original_file_name',
          label: 'View File'
        },
        // {
        //   key: 'file_name',
        //   label: 'Preview'
        // },
        {
          key: 'bank_code',
          label: 'Bank Name'
        },
        {
          key: 'branch_name'
        },
        {
          key: 'account_num',
          label: 'Account No'
        },
        {
          key: 'ifsc',
          label: 'IFSC'
        },
        {
          key: 'beneficiary_name'
        }
      ],
      partyReqId: null,
      wfDtlId: null,
      eventId: null,
      approvalStatus: null,
      downloadDocUrl: URL_UTILITY.getOpenKmDocDeleteUrl,
      uploadedFileName: null,
      showOpenModal: false,
      docDtlId: null,
      authToken: null,
      openKmAuth: null,
      tempToken: null,
      dynamicData:null,
      currentPageIndex:null,
      accessButtons: {
        deleteAllow: false,
        downloadAllow: false,
        uploadAllow: false,
        editAllow: false,
        addAllow: false,
        printAllow: false,
        approvalAllow: false,
        newTab: true,
      },
      bankDocumentsModal:false,
      partyBankReqId:null,
      bankDocumentsData: [],
      bankDocumentsFields: [
        {
          key: 'doc_category_vset',
          label:'Category'
        },
        {
          key: 'original_file_name',
          label:'File Name'
        },
        {
          key: 'preview',
          label:'Preview'
        }
      ],
    };
  },
  mounted() {
    if (this.partyRowDetails) {
      this.partyReqId = this.partyRowDetails.req_id;
      this.wfDtlId = this.partyRowDetails.inprocess_dtl_id;
      this.eventId = this.workflowId.eventId;
    }
    if (this.urlSummaryData) {
      this.partyReqId = this.urlSummaryData.PARTY_REQ_ID;
      this.wfDtlId = this.urlSummaryData.wf_inprocess_dtl_id;
      this.eventId = this.urlSummaryData.wf_event_id;
    }
    if (this.dashboardDetails) {
      this.partyReqId = this.dashboardDetails.party_req_id;
    }
    this.getVendorBankDetails();
  },
  methods: {
    tempFunction() {
      const token = commonHelper.getOpenKmAuthToken();
      token.then(key => {
        if (key) alert('Hi.!!');
      });
    },
    openPreviewDoc(flag, fileName, index, data) {
      const filterDynamicData = data.filter((a) => a.original_file_name);
      const getFileName = data[index].original_file_name;
      for (let i = 0; i < filterDynamicData.length; i++) {
        if (filterDynamicData[i].original_file_name == getFileName) {
          this.currentPageIndex = i + 1;
          break;
        }
      }
      this.dynamicData = filterDynamicData;
      if (flag) {
        this.getOpenKmAuthTokenPreview(flag, fileName);
        // this.timeout = setTimeout(() => {
        //   // this.showHideOpenModal(flag, docDtlId, this.openKmAuth, fileName); // previous function
        //   this.partOnboardingPreview(flag, docDtlId, this.openKmAuth, fileName);
        // }, 1000);
      }
    },
    partOnboardingPreview(flag, docDtlId, authToken, fileName) {
      if (flag) {
        this.fileExtension = commonHelper.getFileExtension(fileName);
      }
      if (this.fileExtension === 'xlsx') {
        alert('Not Allowed');
      } else {
        // this.showOpenModal = flag;
        this.docDtlId = docDtlId;
        this.authToken = authToken;
        this.uploadedFileName = fileName;
        this.previewOpenDoc();    
      }     
    },
    previewOpenDoc() {
      this.fileExtension = commonHelper.getFileExtension(this.uploadedFileName);
      const payload = {
        docDetailId: this.docDtlId,
        token: this.authToken,
        fileExtension: this.fileExtension
      };
      this.loader = true;
      commonHelper.previewImgDocParty(payload);
       this.loader =false
    },
    showHideOpenModal(flag, authToken, fileName) {
      if (flag) {
        this.fileExtension = commonHelper.getFileExtension(fileName);
      }
      if (this.fileExtension === 'xlsx') {
        alert('Not Allowed');
      } else {
        this.showOpenModal = flag;
        this.docDtlId = this.docDetlsId;
        this.authToken = authToken;
        this.uploadedFileName = fileName;
        this.showOpenModal = false;
        setTimeout(() => {
          this.showOpenModal = flag;
        }, 500)
      }
    },
    getVendorBankDetails() {
      const payload = {
        party_req_id: this.partyReqId
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getVendorBankDetails', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            this.bankData = resp.data.data;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getOpenKmAuthTokenPreview(flag, fileName) {
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/openKmPartyPortalAuthenticate')
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.openKmAuth = response.data.data.token;
            if(this.openKmAuth){
              // this.partOnboardingPreview(flag, docDtlId, this.openKmAuth, fileName);
              this.showHideOpenModal(flag, this.openKmAuth, fileName)
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getOpenKmAuthToken(fileName) {
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/openKmPartyPortalAuthenticate')
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.openKmAuth = response.data.data.token;
            const url =
              this.downloadDocUrl +
              '/download/' +
              this.docDetlsId +
              '?token=' +
              this.openKmAuth;
            commonHelper.downloadFile(url, fileName);
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    viewBankDocuments(flag, item) {
      if(flag){
        this.partyBankReqId = item.party_bank_req_id;
        this.docDetlsId=item.document_det_id
        // this.getBankDocumentsData();
        this.getMenuSubmenuId()
      }
      this.bankDocumentsModal = flag
    },
    getBankDocumentsData(menuId, subMenuId){
      const payload = {
        menu_id: menuId,
        sub_menu_id: subMenuId,
        record_id: this.partyBankReqId,
        // user_id: this.userId,
      };
      this.loader = true;
      this.$store
        .dispatch("intWorkflow/getOpenKmDocDtl", payload)
        .then((resp) => {
          this.loader = false;
          if (resp.status === 200) {
            this.bankDocumentsData = resp.data.data.page;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getMenuSubmenuId() {
      const payload = {
        menu_name: 'OnBoarding',
        sub_menu_name: 'BANK DETAILS'
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getMenuSubmenuId', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            let munuId = resp.data.data.menu_id;
            let subMunuId = resp.data.data.sub_menu_id;
            this.getBankDocumentsData(munuId, subMunuId);
          } else {
             this.$bvToast.toast(resp.response.data.message, {
              title: 'Alert',
              variant: 'danger',
              solid: true
            });
          }
        })
        .catch(() => {
          this.loader = false;
        });
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  }
};
